import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

function authConfig(extra = {}) {
  const token = window.localStorage.getItem('token');
  return {
    ...extra,
    headers: {
      ...(extra.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
}

export async function fetchOperationalIntelligenceOverview(params = {}) {
  const { data } = await axios.get(
    `${API_URL}/api/admin/operational-intelligence/overview`,
    authConfig({ params })
  );
  return data;
}

export async function fetchPreDispatchIntelligence(params = {}) {
  const { data } = await axios.get(
    `${API_URL}/api/admin/operational-intelligence/pre-dispatch`,
    authConfig({ params })
  );
  return data;
}

export async function fetchRecipientIntelligence(phone) {
  const { data } = await axios.get(
    `${API_URL}/api/admin/operational-intelligence/recipient`,
    authConfig({ params: { phone } })
  );
  return data;
}

export async function fetchDeliveryIntelligence(deliveryPointId) {
  const { data } = await axios.get(
    `${API_URL}/api/admin/operational-intelligence/delivery/${deliveryPointId}`,
    authConfig()
  );
  return data;
}

export async function executeOperationalDeliveryAction(deliveryPointId, payload) {
  const { data } = await axios.post(
    `${API_URL}/api/admin/operational-intelligence/delivery/${deliveryPointId}/action`,
    payload,
    authConfig()
  );
  return data;
}

export async function reviewPreDispatchDelivery(deliveryPointId, payload) {
  const { data } = await axios.post(
    `${API_URL}/api/admin/operational-intelligence/pre-dispatch/${deliveryPointId}/review`,
    payload,
    authConfig()
  );
  return data;
}

export function apiErrorMessage(error, fallback = 'No se pudo completar la operación') {
  return error?.response?.data?.message || error?.response?.data?.error || fallback;
}
